
import { useNavigate, useParams } from "react-router-dom";
import { Section } from "../components/styled/Containers.style";
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import { Vspace } from '../components/styled/Separators.style'
import { composeUrl } from "../utils/utils";
import { PATHS } from "../routes/CaiExperienceRouter";
import PageContainerCmp from "./PageContainerCmp";
import FotoDannoVeicolo from "../components/foto-danno-veicolo/FotoDannoVeicolo";
import FotoPrivacyWarning from "../components/foto-privacy-warning/FotoPrivacyWarning";
import { useAppSelector } from "../store/hooks";
import { selectCommunicationData } from "../store";

/* istanbul ignore next */
const Trct_FotoDannoTuoVeicoloPage = () => {
    let navigate = useNavigate();
    let { token } = useParams();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const nextBtnDisabled = !communication?.fotoDanniList || communication.fotoDanniList.length < 3;

    const goToNextStepHandler = () => {
        navigate(composeUrl(token, PATHS.TRCT_FOTO_DANNO_CTP_VEICOLO))
    }

    return (
        <>
            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={PATHS.TRCT_FOTO_DANNO_TUO_VEICOLO}
                nextDisabled={nextBtnDisabled}
            >
                <>
                    <Section>
                        <PageTitle>Foto del danno del tuo veicolo</PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered>Scatta almeno 3 foto del danno del tuo veicolo. Prova a fotografarlo da diverse angolazioni. Ti ricordiamo che le foto devono essere attinenti al danno denunciato.</TextDefault>
                    </Section>

                    <FotoDannoVeicolo />

                    <Section>
                        <FotoPrivacyWarning />
                    </Section>

                </>
            </PageContainerCmp>
        </>

    )
}

export default Trct_FotoDannoTuoVeicoloPage